import { render } from "./sandElTab.vue?vue&type=template&id=b5670dfa&scoped=true"
import script from "./sandElTab.vue?vue&type=script&lang=js"
export * from "./sandElTab.vue?vue&type=script&lang=js"

import "./sandElTab.vue?vue&type=style&index=0&id=b5670dfa&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5670dfa"]])

export default __exports__